import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import { buildValidationFormData, postValidation, failureMessage } from '../services/form_helper'

export default class extends Controller {
  static targets = ['form','frontImage','backImage','add1Image','add2Image'];
  static classes = ['errorm','hide','readonly'];
  static values = {validateurl: String, uploadurl: String, removeimageurl: String, networkErrorMessage: String};

  formTargetConnected(){
    const corpMailType = this.formTarget.querySelector("input[name='user[email_type]']");
    if (corpMailType != undefined){
      this.readonlyUserEmail(corpMailType);
    }
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    // YAS-31 FR-2: 実ファイルではなく1バイトの代理ファイルを送る（空body送信の回避）
    const formData = this.buildFormData();
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  // このフォームは method: :put のため _method が入る。検証用 POST では従来どおり取り除く。
  buildFormData(){
    const formData = buildValidationFormData(this.formTarget);
    formData.delete("_method");
    return formData;
  }

  validateAll(){
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const allErrorE = document.getElementById("allError");
    // YAS-31 FR-3: 旧実装は error コールバックが無く、検証AJAX が失敗すると
    // ボタンを押しても何も起きない無言失敗になっていた（本番実測 月40件）。
    postValidation({
      url: this.validateurlValue,
      buildFormData: () => this.buildFormData(),
      onSuccess: (response)=> {
        if(Object.keys(response).length > 0){
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
              }
            })
          });
          this.clearAllError(allErrorE);
        }else{
          this.clearAllError(allErrorE);
          this.formTarget.submit();
        }
      },
      onFailure: (response)=> {
        if(allErrorE == null){ return; }
        allErrorE.innerHTML = failureMessage(response, this.networkErrorMessageValue);
        allErrorE.classList.remove(this.hideClass);
      }
    });
  }

  clearAllError(allErrorE){
    if(allErrorE == null){ return; }
    allErrorE.innerHTML = '';
    allErrorE.classList.add(this.hideClass);
  }

  addUploadField(){
    if(this.add1ImageTarget.classList.contains(this.hideClass) == false && this.add2ImageTarget.classList.contains(this.hideClass)){
      this.add2ImageTarget.classList.remove(this.hideClass);
    }
    if(this.add1ImageTarget.classList.contains(this.hideClass)){
      this.add1ImageTarget.classList.remove(this.hideClass);
    }
  }
  autoUpload(event){
    const el = event.currentTarget;
    const params = event.params;
    const targetName = params.targetname;
    if(el.value != null && el.value != ""){
      const formData = new FormData(this.formTarget);
      formData.append("type",targetName);
      formData.delete("_method");
      Rails.ajax({
        url: this.uploadurlValue,
        type: "POST",
        dataType: 'json',
        data: formData,
        success: (response) => {
          if(response.error != null){
            document.getElementById("insurance_cards_"+targetName+"_error_message").textContent = response.error;
          }else {
            const viewDiv = document.getElementById("image_view_" + targetName);
            const image = viewDiv.querySelector("img");
            image.src = response.image_url;
            viewDiv.classList.remove(this.hideClass);
            document.getElementById("image_upload_" + targetName).classList.add(this.hideClass);
            document.getElementById("insurance_cards_id").value = response.ic_id;
            document.getElementById("insurance_cards_" + targetName + "_error_message").textContent = "";
          }
        }
      });
    }
  }

  removeImage(event){
    const params = event.params;
    const targetName = params.targetname;
    const formData = new FormData(this.formTarget);
    formData.append("type",targetName);
    formData.delete("_method");
    Rails.ajax({
      url: this.removeimageurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        console.log(response);
        const viewDiv = document.getElementById("image_view_"+targetName);
        const image = viewDiv.querySelector("img");
        image.src = "";
        viewDiv.classList.add(this.hideClass);
        document.getElementById("image_upload_"+targetName).classList.remove(this.hideClass);
      }
    });
  }

  corpMail(e){
    const el = e.currentTarget;
    this.readonlyUserEmail(el);
  }
  readonlyUserEmail(el){
    const userMail = this.formTarget.querySelector("#user_email");
    if(el.value == "1"){
      userMail.classList.add(this.readonlyClass);
      userMail.readOnly = true;
    }else{
      userMail.classList.remove(this.readonlyClass);
      userMail.readOnly = false;
    }
  }

}
